import { IRoomEvent, IStateEvent } from "../types";

export interface ChatRoomNewContentsCollection {
  [reactionId: string]: ChatRoomNewContentCollection;
}

export default class ChatRoomNewContentCollection {
  constructor(private collection: Array<IRoomEvent | IStateEvent> = []) {
    this.sort();
  }

  add(event: IRoomEvent | IStateEvent): void {
    this.appendToCollection(event);
    this.sort();
  }

  merge(collection: Array<IRoomEvent | IStateEvent>): void {
    collection.forEach((event) => this.appendToCollection(event));
    this.sort();
  }

  get iterators(): Array<IRoomEvent | IStateEvent> {
    return [...this.collection];
  }

  last(): IRoomEvent | IStateEvent | undefined {
    if (this.collection.length > 0) {
      return this.collection[this.collection.length - 1];
    }
    return undefined;
  }

  private sort(): void {
    this.collection.sort((a, b) => a.origin_server_ts - b.origin_server_ts);
  }

  private appendToCollection(incomingEvent: IRoomEvent | IStateEvent): void {
    this.collection.push(incomingEvent);
  }
}
